import StorageIcon from '@mui/icons-material/Storage';
import CopyToClipboard from 'app/components/CopyToClipboard';

type Props = {
  query?: string;
};

/** Copies `meta.query` via shared CopyToClipboard + database (Storage) icon. */
export default function CopyMetricQueryButton({ query }: Props) {
  const text = query?.trim();
  if (!text) return null;

  return (
    <CopyToClipboard
      text={text}
      size="small"
      tooltipTitle="Copy query"
      aria-label="Copy metric query"
      icon={<StorageIcon sx={{ fontSize: '1.1rem' }} />}
      sx={{
        color: 'text.secondary',
        ml: 0,
      }}
    />
  );
}
